import { type E164Number, parsePhoneNumberWithError } from 'libphonenumber-js'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

import { Input } from '@/ui-components/Input'

const PhoneNumber = ({
  value,
  onChange,
  onError,
}: {
  value: string
  onChange: (value: string) => void
  onError?: (value: boolean) => void
}) => {
  const handlePhoneNumberChange = (phoneValue: E164Number | undefined) => {
    if (!phoneValue) {
      return
    }

    try {
      const parsedNumber = parsePhoneNumberWithError(phoneValue)
      const isValid = parsedNumber.isValid()
      onChange(parsedNumber.number)
      onError?.(!isValid) // Pass validation result to parent
    } catch (error) {
      console.error(error)
      onChange(phoneValue) // Still pass the raw value even if parsing fails
      onError?.(true) // Parsing error means invalid
    }
  }

  return (
    <PhoneInput
      placeholder="Enter phone number"
      value={value}
      onChange={handlePhoneNumberChange}
      inputComponent={Input}
      focusInputOnCountrySelection={false}
    />
  )
}

export default PhoneNumber
